import { Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');
const mdSpacing = getTheme('spacing.md');
const lgSpacing = getTheme('spacing.lg');

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40%;
  flex: 1;
`;

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(60),
})`
  color: ${textMain};
  opacity: 0.5;
  margin-bottom: ${lgSpacing}px;
`;

export const Title = styled(Typography).attrs({
  variant: 'xxl',
})`
  font-weight: 600;
  margin-bottom: ${mdSpacing}px;
`;
export const Description = styled(Typography).attrs({
  variant: 'md',
})`
  line-height: 150%;
`;
